<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/italy/tuscany')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/avignonesi')">Avignonesi
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country two-line"
                               :to="localePath('/wine-guide/italy/tuscany/azienda-agricola-casanova-di-neri')">Azienda
                        Agricola Casanova di Neri
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/azienda-salvioni')">Azienda Salvioni
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/castiglione-del-bosco')">Castiglione del Bosco
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/italy/tuscany/conti-constani')">Conti Constani
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/fattoria-le-pupille')">Fattoria Le Pupille
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/fattoria-poggio-di-sotto')">Fattoria Poggio di
                        Sotto
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/fontodi')">Fontodi
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/frescobaldi')">Frescobaldi
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/gianfranco-soldera')">Gianfranco Soldera
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/isole-e-olena')">Isole e Olena
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/marchesi-antinori')">Marchesi Antinori
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/podere-poggio-scalette')">Podere Poggio
                        Scalette
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/poderi-boscarelli')">Poderi Boscarelli
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/rocca-di-frassinello')">Rocca di Frassinello
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/tenuta-dell-ornellaia')">Tenuta dell’Ornellaia
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/tenuta-di-trinoro')">Tenuta di Trinoro
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/tenuta-san-guido')">Tenuta San Guido
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/italy/tuscany')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Conti Constani</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Con gran parte del buon vino italiano, le migliori bottiglie provengono da tenute relativamente giovani. Tenuta
                        dell' Ornellaia ad esempio, piantato nel solo 1982, o Azienda Salvioni, piantato nel 1989 sono solo
                        due esempi che mi vengono in mente. Non così con Conti Costani. La seconda azienda vinicola più antica in
                        Toscana, questa famiglia ha abbastanza storia da rivaleggiare anche con i migliori Bordeaux.
                    </div>

                    <div class="howto-title2">Constani di nome, coerente per natura</div>
                    <div class="howto-text">
                        Con oltre quattro secoli di storia, a 25 ettari (e solo 12 di quei vigneti), la tenuta
                        è sorprendentemente piccolo. Può essere piccolo ma ragazzo è perfettamente formato. Diventare famoso nel
                        Nell'Ottocento, Tito Constanti fu un precursore nel vedere il potenziale dell'uva Brunello. Nota:
                        Brunello è il nome locale del clone dell'uva Sangiovese, anche l'unica uva consentita
                        per ottenere la denominazione DOCG. C'è infatti un record che Tito Costanti ne imbottigliava
                        dell'annata 1865 per una mostra nel 1867, ma purtroppo non rimangono bottiglie.
                        <br><br>
                        Oggi la tenuta è di proprietà e gestita dall'ex geologo Andrea Costanti, subentrato al suo
                        zio, Conte Emilio, nel 1983. Ancora giovanissimo, Andrea si mise a gestire la tenuta come un papero per
                        acqua, la sua esperienza di geologia gli ha dato un vantaggio rispetto ai suoi concorrenti nel capire come farlo al meglio
                        sfruttare a proprio vantaggio i terreni magri, marne del Cretaceo. Questo è stato ancora di più
                        impegnativo, considerando che il terroir di Conti Costani si trova a oltre 400 metri sul livello del mare. Consulente
                        L'enologo Vittorio Fiore ha migliorato ulteriormente la reputazione dei Conti Costani e della tenuta
                        produce un bellissimo e ricco Brunello di Montalcino che nonostante la loro altitudine e quella della regione
                        estati molto calde e inverni molto freddi, sono coerenti nel gusto e nella qualità.
                    </div>

                    <div class="howto-title2">Investitori di vini pregiati, prendete nota!</div>
                    <div class="howto-text">
                        Questo è ancora un produttore piuttosto nascosto, il che è una buona notizia per il buon vino esperto
                        investitore. L'altitudine più fresca si traduce in vini di suprema eleganza con una struttura fine e
                        potere sottostante. Prezzi molto ragionevoli (aspettati di pagare circa € 150 per il superbo Brunello 2012
                        di Montalcino Riserva DOCG), deve ancora essere colto il rapporto qualità prezzo incredibilmente interessante
                        da altre agenzie di investimento del vino. Sorprendente, come tutti e sei i vini Conti Costanti (due
                        Brunello, un Vermiglio e un Rosso di Montalcino, più due Grappe di Brunello), chiaramente
                        rappresenta un valore formidabile rispetto alla loro qualità, storia, reputazione e disponibilità in
                        il mercato.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Conti Constani</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Da ein Großteil der italienischen Spitzenweine stammt, stammen die besten Flaschen von relativ jungen Weingütern. Tenuta
                        dell' Ornellaia zum Beispiel, die erst 1982 gepflanzt wurde, oder Azienda Salvioni, die 1989 gepflanzt wurde, sind gerecht
                        zwei Beispiele, die mir in den Sinn kommen. Nicht so bei Conti Constantani. Das zweitälteste Weingut in
                        In der Toskana hat diese Familie genug Geschichte, um selbst mit dem besten Bordeaux mithalten zu können.
                    </div>

                    <div class="howto-title2">Constani mit Namen, konsistent von Natur aus</div>
                    <div class="howto-text">
                        Mit über vier Jahrhunderten Geschichte, auf 25 Hektar (und nur 12 dieser Weinberge) ist das Anwesen
                        ist überraschend zierlich. Es mag klein sein, aber Junge, es ist perfekt geformt. Berühmtheit erlangt in der
                        Im 19. Jahrhundert war Tito Constanti ein Vorreiter, der das Potenzial der Brunello-Traube erkannte. Notiz:
                        Brunello ist der lokale Name für den Klon der Sangiovese-Traube, auch die einzige zugelassene Traube
                        um eine DOCG-Bezeichnung zu haben. Tatsächlich gibt es eine Aufzeichnung, dass Tito Costanti einige davon abgefüllt hat
                        des Jahrgangs 1865 für eine Ausstellung im Jahr 1867, aber leider sind keine Flaschen mehr übrig.
                        <br><br>
                        Heute ist das Anwesen im Besitz und wird von dem ehemaligen Geologen Andrea Costanti geführt, der sein Amt übernommen hat
                        Onkel, Graf Emilio, im Jahr 1983. Noch in jungen Jahren begann Andrea, das Anwesen wie eine Ente zu führen
                        Wasser, seine geologische Erfahrung verschafft ihm einen Vorsprung gegenüber seinen Mitbewerbern, wenn es darum geht, wie er am besten vorgeht
                        die mageren Mergelböden aus der Kreidezeit optimal zu nutzen. Das war noch mehr
                        eine Herausforderung, wenn man bedenkt, dass das Terroir von Conti Constani über 400 m über dem Meeresspiegel liegt. Berater
                        Der Önologe Vittorio Fiore hat den Ruf von Conti Constani und dem Weingut weiter verbessert
                        produziert einen wunderschönen, reichhaltigen Brunello di Montalcino, der trotz seiner Höhenlage und der Region einzigartig ist
                        sehr heiße Sommer und sehr kalte Winter, sind in Geschmack und Qualität gleichbleibend.
                    </div>

                    <div class="howto-title2">Gute Weininvestoren, aufgepasst!</div>
                    <div class="howto-text">
                        Dies ist immer noch ein eher unbekannter Produzent, was für den versierten guten Wein eine erfreuliche Nachricht ist
                        Investor. Die kühlere Höhenlage führt zu Weinen von höchster Eleganz mit feiner Struktur und
                        zugrunde liegende Macht. Sehr preisgünstig (rechnen Sie mit etwa 150 € für den hervorragenden Brunello 2012).
                        di Montalcino Riserva DOCG), das unglaublich überzeugende Preis-Leistungs-Verhältnis muss noch ausgewählt werden
                        von anderen Wein-Investmentagenturen gegründet. Überraschend, denn alle sechs Weine von Conti Costanti (zwei
                        Brunellos, ein Vermiglio und ein Rosso di Montalcino, dazu zwei Grappa di Brunellos), klar
                        stellt im Verhältnis zu ihrer Qualität, Geschichte, ihrem Ruf und ihrer Verfügbarkeit einen enormen Wert dar
                        der Markt.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Conti Constani</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Avec une grande partie des vins fins italiens, les meilleures bouteilles proviennent de domaines relativement jeunes. Tenuta
                        dell' Ornellaia par exemple, plantée en 1982 seulement, ou Azienda Salvioni, plantée en 1989 ne sont que
                        deux exemples qui me viennent à l'esprit. Ce n'est pas le cas avec Conti Constanti. Le deuxième plus ancien domaine viticole de
                        Toscane, cette famille a assez d'histoire pour rivaliser avec les meilleurs Bordeaux.
                    </div>

                    <div class="howto-title2">Constani par son nom, cohérent par nature</div>
                    <div class="howto-text">
                        Avec plus de quatre siècles d'histoire, sur 25 hectares (et seulement 12 de ces vignobles), le domaine
                        est étonnamment petite. C'est peut-être petit mais le garçon est-il parfaitement formé. Devenu célèbre dans le
                        Au XIXe siècle, Tito Constanti a été un précurseur en voyant le potentiel du cépage Brunello. Note:
                        Brunello est le nom local du clone du cépage Sangiovese, également le seul cépage autorisé
                        afin d'avoir une appellation DOCG. En fait, il y a un disque que Tito Costanti a mis en bouteille
                        du millésime 1865 pour une exposition en 1867, mais il ne reste malheureusement plus de bouteilles.
                        <br><br>
                        Aujourd'hui, le domaine appartient et est géré par l'ancien géologue Andrea Costanti, qui a succédé à son
                        oncle, le comte Emilio, en 1983. Encore très jeune, Andrea s'est mise à diriger le domaine comme un canard pour
                        l'eau, son expérience en géologie lui donne un avantage sur ses concurrents pour comprendre comment mieux
                        utiliser au mieux les sols maigres et marneux du Crétacé. Cela a été encore plus
                        difficile, étant donné que le terroir de Conti Constanti est à plus de 400 m d'altitude. Consultant
                        l'œnologue Vittorio Fiore a encore amélioré la réputation de Conti Constani, et le domaine
                        produit de beaux et riches Brunello di Montalcino qui malgré leur altitude et la région
                        des étés très chauds et des hivers très froids, sont constants en goût et en qualité.
                    </div>

                    <div class="howto-title2">Investisseurs de vins fins, prenez note!</div>
                    <div class="howto-text">
                        C'est encore un producteur assez discret, ce qui est une bonne nouvelle pour le bon vin avisé
                        investisseur. L'altitude plus fraîche donne des vins d'une élégance suprême avec une structure fine et
                        puissance sous-jacente. Prix très raisonnable (comptez environ 150 € pour le superbe Brunello 2012
                        di Montalcino Riserva DOCG), le rapport qualité-prix incroyablement convaincant n'a pas encore été choisi
                        par d'autres agences d'investissement dans le vin. Surprenant, car les six vins de Conti Costanti (deux
                        Brunellos, un Vermiglio et un Rosso di Montalcino, plus deux Grappa di Brunellos), clairement
                        représente une valeur formidable par rapport à leur qualité, leur histoire, leur réputation et leur disponibilité dans
                        le marché.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Conti Constani</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        With much of Italian fine wine, the best bottles come from relatively young estates. Tenuta
                        dell' Ornellaia for example, planted in just 1982, or Azienda Salvioni, planted in 1989 are just
                        two examples that come to mind. Not so with Conti Constani. The second oldest wine estate in
                        Tuscany, this family has enough history to rival even the best Bordeaux.
                    </div>

                    <div class="howto-title2">Constani by name, consistent by nature</div>
                    <div class="howto-text">
                        With over four centuries of history, at 25-hectares (and just 12 of those vineyards), the estate
                        is surprisingly petite. It may be small but boy is it perfectly formed. Springing to fame in the
                        19th-century, Tito Constanti was a forerunner in seeing the Brunello grape’s potential. Note:
                        Brunello is the local name for the clone of the Sangiovese grape, also the only grape permitted
                        in order to have a DOCG appellation. In fact, there is a record that Tito Costanti bottled some
                        of the 1865 vintage for an exhibition in 1867, but sadly no bottles remain.
                        <br><br>
                        Today the estate is owned and run by former geologist Andrea Costanti, who took over from his
                        uncle, Count Emilio, in 1983. Still very young, Andrea took to running the estate like a duck to
                        water, his geology experience giving him the edge over his competitors in understanding how best
                        to use the lean, Cretaceous marl, soils to his best advantage. This has been even more
                        challenging, considering Conti Constani’s terroir is over 400m above sea level. Consultant
                        oenologist Vittorio Fiore has improved Conti Constani’s reputation further, and the estate
                        produces beautiful, rich Brunello di Montalcino that despite their altitude and the region’s
                        very hot summers and very cold winters, are consistent in taste and quality.
                    </div>

                    <div class="howto-title2">Fine wine investors, take note!</div>
                    <div class="howto-text">
                        This is still quite an under-the-radar producer, which is happy news for the savvy fine wine
                        investor. The cooler altitude results in wines of supreme elegance with a fine structure and
                        underlying power. Very reasonably priced (expect to pay around €150 for the superb 2012 Brunello
                        di Montalcino Riserva DOCG), the incredibly compelling price-quality ratio has yet to be picked
                        up by other wine investment agencies. Surprising, as all six of Conti Costanti wines (two
                        Brunellos, a Vermiglio and a Rosso di Montalcino, plus two Grappa di Brunellos), clearly
                        represents a terrific value relative to their quality, history, reputation and availability in
                        the market.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ContiConstani",
    head: {
        title: 'Conti Constani | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the excellence of Conti Costanti, a leading Tuscany wine producer, known for their exceptional and diverse range of premium Italian wines.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    },
    data() {
        return {
            select: {report: 'Conti Constani', src: '/wine-guide/italy/tuscany/conti-constani'},
            items: [
                {report: 'Avignonesi', src: '/wine-guide/italy/tuscany/аvignonesi'},
                {
                    report: 'Azienda Agricola Casanova di Neri',
                    src: '/wine-guide/italy/tuscany/azienda-agricola-casanova-di-neri'
                },
                {report: 'Azienda Salvioni', src: '/wine-guide/italy/tuscany/azienda-salvioni'},
                {report: 'Castiglione del Bosco', src: '/wine-guide/italy/tuscany/castiglione-del-bosco'},
                {report: 'Conti Constani', src: '/wine-guide/italy/tuscany/conti-constani'},
                {report: 'Fattoria Le Pupille', src: '/wine-guide/italy/tuscany/fattoria-le-pupille'},
                {report: 'Fattoria Poggio di Sotto', src: '/wine-guide/italy/tuscany/fattoria-poggio-di-sotto'},
                {report: 'Fontodi', src: '/wine-guide/italy/tuscany/fontodi'},
                {report: 'Frescobaldi', src: '/wine-guide/italy/tuscany/frescobaldi'},
                {report: 'Gianfranco Soldera', src: '/wine-guide/italy/tuscany/gianfranco-soldera'},
                {report: 'Isole e Olena', src: '/wine-guide/italy/tuscany/isole-e-olena'},
                {report: 'Marchesi Antinori', src: '/wine-guide/italy/tuscany/marchesi-antinori'},
                {report: 'Podere Poggio Scalette', src: '/wine-guide/italy/tuscany/podere-poggio-scalette'},
                {report: 'Poderi Boscarelli', src: '/wine-guide/italy/tuscany/poderi-boscarelli'},
                {report: 'Tenuta dell’Ornellaia', src: '/wine-guide/italy/tuscany/tenuta-dell-ornellaia'},
                {report: 'Tenuta di Trinoro', src: '/wine-guide/italy/tuscany/tenuta-di-trinoro'},
                {report: 'Tenuta San Guido', src: '/wine-guide/italy/tuscany/tenuta-san-guido'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
